import http from './api'

const route = 'app/comercial/clientes/'

export default {
  // this.dataInicial, this.dataFinal, this.empresaSelect, localStorage.tokencontrato, this.vendedores, this.areaSelect, this.redeSelect, this.supervisorSelect, this.receitaSelect
  showClientesFaturados: (dataInicial, dataFinal, select, tokenContrato, vendedorSelect, areaSelect, redeSelect, supervisorSelect, receita, segmento, categoria, promotor) => {
    return http.post(route + 'showClientesFaturados', {
      dataInicio: dataInicial,
      dataFim: dataFinal,
      select: select,
      tokenContrato: tokenContrato,
      vendedor: vendedorSelect,
      area: areaSelect,
      rede: redeSelect,
      supervisor: supervisorSelect,
      receita: receita,
      segmento: segmento,
      categoria: categoria,
      promotor: promotor,
    })
  },

  showLocalizacaoClientes: (dataInicial, dataFinal, select, tokenContrato, vendedorSelect, areaSelect, redeSelect, supervisorSelect) => {
    return http.post(route + 'showLocalizacaoClientes', {
      dataInicio: dataInicial,
      dataFim: dataFinal,
      select: select,
      tokenContrato: tokenContrato,
      vendedor: vendedorSelect,
      area: areaSelect,
      rede: redeSelect,
      supervisor: supervisorSelect,
    })
  },

  showDetalheClientesFaturados: (dataInicial, dataFinal, select, tokenContrato, vendedorSelect, areaSelect, redeSelect, supervisorSelect, categoria, promotor) => {
    return http.post(route + 'showDetalheClientesFaturados', {
      dataInicio: dataInicial,
      dataFim: dataFinal,
      select: select,
      tokenContrato: tokenContrato,
      vendedor: vendedorSelect,
      area: areaSelect,
      rede: redeSelect,
      supervisor: supervisorSelect,
      categoria: categoria,
      promotor: promotor,
    })
  },

  showDetalheTotalClientes: (dataInicial, dataFinal, select, tokenContrato, vendedorSelect, areaSelect, redeSelect, supervisorSelect, categoria, promotor) => {
    return http.post(route + 'showDetalheTotalClientes', {
      dataInicio: dataInicial,
      dataFim: dataFinal,
      select: select,
      tokenContrato: tokenContrato,
      vendedor: vendedorSelect,
      area: areaSelect,
      rede: redeSelect,
      supervisor: supervisorSelect,
      categoria: categoria,
      promotor: promotor,
    })
  },

  showLocalizacaoCliente: (dataInicial, dataFinal, select, tokenContrato, vendedorSelect, areaSelect, redeSelect, supervisorSelect, receita, segmento, categoria, promotor) => {
    return http.post(route + 'showLocalizacaoCliente', {
      dataInicio: dataInicial,
      dataFim: dataFinal,
      select: select,
      tokenContrato: tokenContrato,
      vendedor: vendedorSelect,
      area: areaSelect,
      rede: redeSelect,
      supervisor: supervisorSelect,
      receita: receita,
      segmento: segmento,
      categoria: categoria,
      promotor: promotor,
    })
  },

  showClientesNovos: (dataInicial, dataFinal, select, tokenContrato, vendedorSelect, areaSelect, redeSelect, supervisorSelect, receita, segmento, categoria, promotor) => {
    return http.post(route + 'showClientesNovos', {
      dataInicio: dataInicial,
      dataFim: dataFinal,
      select: select,
      tokenContrato: tokenContrato,
      vendedor: vendedorSelect,
      area: areaSelect,
      rede: redeSelect,
      supervisor: supervisorSelect,
      receita: receita,
      segmento: segmento,
      categoria: categoria,
      promotor: promotor,
    })
  },

  showNovosClientesFaturados: (dataInicial, dataFinal, select, tokenContrato, vendedorSelect, areaSelect, redeSelect, supervisorSelect, categoria, promotor) => {
    return http.post(route + 'showNovosClientesFaturados', {
      dataInicio: dataInicial,
      dataFim: dataFinal,
      select: select,
      tokenContrato: tokenContrato,
      vendedor: vendedorSelect,
      area: areaSelect,
      rede: redeSelect,
      supervisor: supervisorSelect,
      categoria: categoria,
      promotor: promotor,
    })
  },

  showComparativoClientes: (dataInicial, dataFinal, select, tokenContrato, vendedorSelect, areaSelect, redeSelect, supervisorSelect, receita, segmento, categoria, promotor) => {
    return http.post(route + 'showComparativoClientes', {
      dataInicio: dataInicial,
      dataFim: dataFinal,
      select: select,
      tokenContrato: tokenContrato,
      vendedor: vendedorSelect,
      area: areaSelect,
      rede: redeSelect,
      supervisor: supervisorSelect,
      receita: receita,
      segmento: segmento,
      categoria: categoria,
      promotor: promotor,
    })
  },

  showDistribuicaoClientesAnual: (dataInicial, dataFinal, select, tokenContrato, vendedorSelect, areaSelect, redeSelect, supervisorSelect, receita, segmento, categoria, promotor) => {
    return http.post(route + 'showDistribuicaoClientesAnual', {
      dataInicio: dataInicial,
      dataFim: dataFinal,
      select: select,
      tokenContrato: tokenContrato,
      vendedor: vendedorSelect,
      area: areaSelect,
      rede: redeSelect,
      supervisor: supervisorSelect,
      receita: receita,
      segmento: segmento,
      categoria: categoria,
      promotor: promotor,
    })
  },

  showClientesSemFaturamento: (dataInicial, dataFinal, select, tokenContrato, vendedorSelect, areaSelect, redeSelect, supervisorSelect, receita, segmento, categoria, promotor) => {
    return http.post(route + 'showClientesSemFaturamento', {
      dataInicio: dataInicial,
      dataFim: dataFinal,
      select: select,
      tokenContrato: tokenContrato,
      vendedor: vendedorSelect,
      area: areaSelect,
      rede: redeSelect,
      supervisor: supervisorSelect,
      receita: receita,
      segmento: segmento,
      categoria: categoria,
      promotor: promotor,
    })
  },

  showMelhoresClientes: (dataInicial, dataFinal, select, tokenContrato, vendedorSelect, areaSelect, redeSelect, supervisorSelect, receita, segmento, categoria, promotor) => {
    return http.post(route + 'showMelhoresClientes', {
      dataInicio: dataInicial,
      dataFim: dataFinal,
      select: select,
      tokenContrato: tokenContrato,
      vendedor: vendedorSelect,
      area: areaSelect,
      rede: redeSelect,
      supervisor: supervisorSelect,
      receita: receita,
      segmento: segmento,
      categoria: categoria,
      promotor: promotor,
    })
  },

  showSegmentacaoClientes: (dataInicial, dataFinal, select, tokenContrato, vendedorSelect, areaSelect, redeSelect, supervisorSelect, receita, segmento, categoria, promotor) => {
    return http.post(route + 'showSegmentacaoClientes', {
      dataInicio: dataInicial,
      dataFim: dataFinal,
      select: select,
      tokenContrato: tokenContrato,
      vendedor: vendedorSelect,
      area: areaSelect,
      rede: redeSelect,
      supervisor: supervisorSelect,
      receita: receita,
      segmento: segmento,
      categoria: categoria,
      promotor: promotor,
    })
  },

  showDevolucaoClientes: (dataInicial, dataFinal, select, tokenContrato, vendedorSelect, areaSelect, redeSelect, supervisorSelect, receita, segmento, categoria, promotor) => {
    return http.post(route + 'showDevolucaoClientes', {
      dataInicio: dataInicial,
      dataFim: dataFinal,
      select: select,
      tokenContrato: tokenContrato,
      vendedor: vendedorSelect,
      area: areaSelect,
      rede: redeSelect,
      supervisor: supervisorSelect,
      receita: receita,
      segmento: segmento,
      categoria: categoria,
      promotor: promotor,
    })
  },

  showPerformanceTicketMedio: (dataInicial, dataFinal, select, tokenContrato, vendedorSelect, areaSelect, redeSelect, supervisorSelect, receita, segmento, categoria, promotor) => {
    return http.post(route + 'showPerformanceTicketMedio', {
      dataInicio: dataInicial,
      dataFim: dataFinal,
      select: select,
      tokenContrato: tokenContrato,
      vendedor: vendedorSelect,
      area: areaSelect,
      rede: redeSelect,
      supervisor: supervisorSelect,
      receita: receita,
      segmento: segmento,
      categoria: categoria,
      promotor: promotor,
    })
  },

  showClientesMaioresCrescimento: (dataInicial, dataFinal, select, tokenContrato, vendedorSelect, areaSelect, redeSelect, supervisorSelect, receita, segmento, categoria, promotor) => {
    return http.post(route + 'showClientesMaioresCrescimento', {
      dataInicio: dataInicial,
      dataFim: dataFinal,
      select: select,
      tokenContrato: tokenContrato,
      vendedor: vendedorSelect,
      area: areaSelect,
      rede: redeSelect,
      supervisor: supervisorSelect,
      receita: receita,
      segmento: segmento,
      categoria: categoria,
      promotor: promotor,
    })
  },

  showClientesPioresCrescimento: (dataInicial, dataFinal, select, tokenContrato, vendedorSelect, areaSelect, redeSelect, supervisorSelect, receita, segmento, categoria, promotor) => {
    return http.post(route + 'showClientesPioresCrescimento', {
      dataInicio: dataInicial,
      dataFim: dataFinal,
      select: select,
      tokenContrato: tokenContrato,
      vendedor: vendedorSelect,
      area: areaSelect,
      rede: redeSelect,
      supervisor: supervisorSelect,
      receita: receita,
      segmento: segmento,
      categoria: categoria,
      promotor: promotor,
    })
  },

  showDetalheMelhoresClientesFaturados: (dataInicial, dataFinal, select, tokenContrato, vendedorSelect, areaSelect, redeSelect, supervisorSelect, receita, categoria, promotor) => {
    return http.post(route + 'showDetalheMelhoresClientesFaturados', {
      dataInicio: dataInicial,
      dataFim: dataFinal,
      select: select,
      tokenContrato: tokenContrato,
      vendedor: vendedorSelect,
      area: areaSelect,
      rede: redeSelect,
      supervisor: supervisorSelect,
      receita: receita,
      categoria: categoria,
      promotor: promotor,
    })
  },

  showClientesCampeoes: (dataInicial, dataFinal, select, tokenContrato, vendedorSelect, areaSelect, redeSelect, supervisorSelect, receita, segmento, categoria, promotor) => {
    return http.post(route + 'showClientesCampeoes', {
      dataInicio: dataInicial,
      dataFim: dataFinal,
      select: select,
      tokenContrato: tokenContrato,
      vendedor: vendedorSelect,
      area: areaSelect,
      rede: redeSelect,
      supervisor: supervisorSelect,
      receita: receita,
      segmento: segmento,
      categoria: categoria,
      promotor: promotor,
    })
  },

  showClientesLeais: (dataInicial, dataFinal, select, tokenContrato, vendedorSelect, areaSelect, redeSelect, supervisorSelect, receita, segmento, categoria, promotor) => {
    return http.post(route + 'showClientesLeais', {
      dataInicio: dataInicial,
      dataFim: dataFinal,
      select: select,
      tokenContrato: tokenContrato,
      vendedor: vendedorSelect,
      area: areaSelect,
      rede: redeSelect,
      supervisor: supervisorSelect,
      receita: receita,
      segmento: segmento,
      categoria: categoria,
      promotor: promotor,
    })
  },

  showClientesHibernando: (dataInicial, dataFinal, select, tokenContrato, vendedorSelect, areaSelect, redeSelect, supervisorSelect, receita, segmento, categoria, promotor) => {
    return http.post(route + 'showClientesHibernando', {
      dataInicio: dataInicial,
      dataFim: dataFinal,
      select: select,
      tokenContrato: tokenContrato,
      vendedor: vendedorSelect,
      area: areaSelect,
      rede: redeSelect,
      supervisor: supervisorSelect,
      receita: receita,
      segmento: segmento,
      categoria: categoria,
      promotor: promotor,
    })
  },

  showNovosClientes: (dataInicial, dataFinal, select, tokenContrato, vendedorSelect, areaSelect, redeSelect, supervisorSelect, receita, segmento, promotor) => {
    return http.post(route + 'showNovosClientes', {
      dataInicio: dataInicial,
      dataFim: dataFinal,
      select: select,
      tokenContrato: tokenContrato,
      vendedor: vendedorSelect,
      area: areaSelect,
      rede: redeSelect,
      supervisor: supervisorSelect,
      receita: receita,
      segmento: segmento,
      promotor: promotor,
    })
  },

  showClientesPreocupantes: (dataInicial, dataFinal, select, tokenContrato, vendedorSelect, areaSelect, redeSelect, supervisorSelect, receita, segmento, categoria, promotor) => {
    return http.post(route + 'showClientesPreocupantes', {
      dataInicio: dataInicial,
      dataFim: dataFinal,
      select: select,
      tokenContrato: tokenContrato,
      vendedor: vendedorSelect,
      area: areaSelect,
      rede: redeSelect,
      supervisor: supervisorSelect,
      receita: receita,
      segmento: segmento,
      categoria: categoria,
      promotor: promotor,
    })
  },

  showClientesPromissoresEPotencias: (dataInicial, dataFinal, select, tokenContrato) => {
    return http.post(route + 'showClientesPromissoresEPotencias', {
      dataInicio: dataInicial,
      dataFim: dataFinal,
      select: select,
      tokenContrato: tokenContrato,
    })
  },

  showLocalizacaoClienteRFC: (dadosCampeoes, dadosPromissores, dadosPotencias, dadosLeais, dadosHibernando, dadosRisco, dadosNovos, dadosPreocupantes, dadosNaoPerder, tokenContrato, dataInicial, dataFinal, vendedorSelect, areaSelect, redeSelect, supervisorSelect, receita, select, segmento, categoria, promotor) => {
    return http.post(route + 'showLocalizacaoClienteRFC', {
      dadosCampeoes: dadosCampeoes,
      dadosPromissores: dadosPromissores,
      dadosPotenciais: dadosPotencias,
      dadosLeais: dadosLeais,
      dadosHibernando: dadosHibernando,
      dadosRisco: dadosRisco,
      dadosNovos: dadosNovos,
      dadosPreocupantes: dadosPreocupantes,
      dadosNaoPerder: dadosNaoPerder,
      tokenContrato: tokenContrato,
      dataInicio: dataInicial,
      dataFim: dataFinal,
      vendedor: vendedorSelect,
      area: areaSelect,
      rede: redeSelect,
      supervisor: supervisorSelect,
      receita: receita,
      select: select,
      segmento: segmento,
      categoria: categoria,
      promotor: promotor,
    })
  },

  showDadosClientes: (tokenContrato) => {
    return http.post(route + 'showDadosClientes', {
      tokenContrato: tokenContrato,
    })
  },

  showFaturamentoCliente: (primeiroDia, ultimoDia, select, selectCliente, tokenContrato, vendedorSelect, areaSelect, redeSelect, supervisorSelect, receita, categoria, promotor) => {
    return http.post(route + 'showFaturamentoCliente', {
      dataInicio: primeiroDia,
      dataFim: ultimoDia,
      select: select,
      selectCliente: selectCliente,
      tokenContrato: tokenContrato,
      vendedor: vendedorSelect,
      area: areaSelect,
      rede: redeSelect,
      supervisor: supervisorSelect,
      receita: receita,
      categoria: categoria,
      promotor: promotor,
    })
  },

  showDadosComparativoFaturamentoCliente: (primeiroDia, ultimoDia, select, selectCliente, tokenContrato, vendedorSelect, areaSelect, redeSelect, supervisorSelect, receita, categoria, promotor) => {
    return http.post(route + 'showDadosComparativoFaturamentoCliente', {
      dataInicio: primeiroDia,
      dataFim: ultimoDia,
      select: select,
      selectCliente: selectCliente,
      tokenContrato: tokenContrato,
      vendedor: vendedorSelect,
      area: areaSelect,
      rede: redeSelect,
      supervisor: supervisorSelect,
      receita: receita,
      categoria: categoria,
      promotor: promotor,
    })
  },

  showQuantidadeCliente: (primeiroDia, ultimoDia, select, selectCliente, tokenContrato, vendedorSelect, areaSelect, redeSelect, supervisorSelect, receita, categoria, promotor) => {
    return http.post(route + 'showQuantidadeCliente', {
      dataInicio: primeiroDia,
      dataFim: ultimoDia,
      select: select,
      selectCliente: selectCliente,
      tokenContrato: tokenContrato,
      vendedor: vendedorSelect,
      area: areaSelect,
      rede: redeSelect,
      supervisor: supervisorSelect,
      receita: receita,
      categoria: categoria,
    })
  },

  showTicketMedio: (primeiroDia, ultimoDia, select, selectCliente, tokenContrato, vendedorSelect, areaSelect, redeSelect, supervisorSelect, receita, categoria, promotor) => {
    return http.post(route + 'showTicketMedio', {
      dataInicio: primeiroDia,
      dataFim: ultimoDia,
      select: select,
      selectCliente: selectCliente,
      tokenContrato: tokenContrato,
      vendedor: vendedorSelect,
      area: areaSelect,
      rede: redeSelect,
      supervisor: supervisorSelect,
      receita: receita,
      categoria: categoria,
      promotor: promotor,
    })
  },

  showEvolucaoSemestral: (primeiroDia, ultimoDia, select, selectCliente, tokenContrato, vendedorSelect, areaSelect, redeSelect, supervisorSelect, receita, categoria, promotor) => {
    return http.post(route + 'showEvolucaoSemestral', {
      dataInicio: primeiroDia,
      dataFim: ultimoDia,
      select: select,
      selectCliente: selectCliente,
      tokenContrato: tokenContrato,
      vendedor: vendedorSelect,
      area: areaSelect,
      rede: redeSelect,
      supervisor: supervisorSelect,
      receita: receita,
      categoria: categoria,
      promotor: promotor,
    })
  },

  showMixComercializado: (primeiroDia, ultimoDia, select, selectCliente, tokenContrato, vendedorSelect, areaSelect, redeSelect, supervisorSelect, receita, categoria, promotor) => {
    return http.post(route + 'showMixComercializado', {
      dataInicio: primeiroDia,
      dataFim: ultimoDia,
      select: select,
      selectCliente: selectCliente,
      tokenContrato: tokenContrato,
      vendedor: vendedorSelect,
      area: areaSelect,
      rede: redeSelect,
      supervisor: supervisorSelect,
      receita: receita,
      categoria: categoria,
      promotor: promotor,
    })
  },

  showPerfilMixComprado: (primeiroDia, ultimoDia, select, selectCliente, tokenContrato, vendedorSelect, areaSelect, redeSelect, supervisorSelect, receita, categoria, promotor) => {
    return http.post(route + 'showPerfilMixComprado', {
      dataInicio: primeiroDia,
      dataFim: ultimoDia,
      select: select,
      selectCliente: selectCliente,
      tokenContrato: tokenContrato,
      vendedor: vendedorSelect,
      area: areaSelect,
      rede: redeSelect,
      supervisor: supervisorSelect,
      receita: receita,
      categoria: categoria,
      promotor: promotor,
    })
  },

  showDevolucaoCliente: (primeiroDia, ultimoDia, select, selectCliente, tokenContrato, vendedorSelect, areaSelect, redeSelect, supervisorSelect, receita, categoria, promotor) => {
    return http.post(route + 'showDevolucaoCliente', {
      dataInicio: primeiroDia,
      dataFim: ultimoDia,
      select: select,
      selectCliente: selectCliente,
      tokenContrato: tokenContrato,
      vendedor: vendedorSelect,
      area: areaSelect,
      rede: redeSelect,
      supervisor: supervisorSelect,
      receita: receita,
      categoria: categoria,
      promotor: promotor,
    })
  },

  showProdutoVenderEFocar: (primeiroDia, ultimoDia, select, selectCliente, tokenContrato, vendedorSelect, areaSelect, redeSelect, supervisorSelect, receita, categoria, promotor) => {
    return http.post(route + 'showProdutoVenderEFocar', {
      dataInicio: primeiroDia,
      dataFim: ultimoDia,
      select: select,
      selectCliente: selectCliente,
      tokenContrato: tokenContrato,
      vendedor: vendedorSelect,
      area: areaSelect,
      rede: redeSelect,
      supervisor: supervisorSelect,
      receita: receita,
      categoria: categoria,
      promotor: promotor,
    })
  },

  showDadosABCCliente: (primeiroDia, ultimoDia, select, tokenContrato, vendedorSelect, areaSelect, redeSelect, supervisorSelect, receita, segmento, categoria, promotor) => {
    return http.post(route + 'showDadosABCCliente', {
      dataInicio: primeiroDia,
      dataFim: ultimoDia,
      select: select,
      tokenContrato: tokenContrato,
      vendedor: vendedorSelect,
      area: areaSelect,
      rede: redeSelect,
      supervisor: supervisorSelect,
      receita: receita,
      segmento: segmento,
      categoria: categoria,
      promotor: promotor,
    })
  },

  showMatrizRiscoRFV: (primeiroDia, ultimoDia, select, tokenContrato, vendedorSelect, areaSelect, redeSelect, supervisorSelect, receita, segmento, categoria, promotor) => {
    return http.post(route + 'showMatrizRiscoRFV', {
      dataInicio: primeiroDia,
      dataFim: ultimoDia,
      select: select,
      tokenContrato: tokenContrato,
      vendedor: vendedorSelect,
      area: areaSelect,
      rede: redeSelect,
      supervisor: supervisorSelect,
      receita: receita,
      segmento: segmento,
      categoria: categoria,
      promotor: promotor,
    })
  },

  showDelhamentoClientesSemFaturamento: (primeiroDia, ultimoDia, select, tokenContrato, vendedorSelect, areaSelect, redeSelect, supervisorSelect, receita, categoria, promotor) => {
    return http.post(route + 'showDelhamentoClientesSemFaturamento', {
      dataInicio: primeiroDia,
      dataFim: ultimoDia,
      select: select,
      tokenContrato: tokenContrato,
      vendedor: vendedorSelect,
      area: areaSelect,
      rede: redeSelect,
      supervisor: supervisorSelect,
      receita: receita,
      categoria: categoria,
      promotor: promotor,
    })
  },

  showDelhamentoClientesDadosDevolucao: (primeiroDia, ultimoDia, select, tokenContrato, vendedorSelect, areaSelect, redeSelect, supervisorSelect, receita, categoria, promotor) => {
    return http.post(route + 'showDelhamentoClientesDadosDevolucao', {
      dataInicio: primeiroDia,
      dataFim: ultimoDia,
      select: select,
      tokenContrato: tokenContrato,
      vendedor: vendedorSelect,
      area: areaSelect,
      rede: redeSelect,
      supervisor: supervisorSelect,
      receita: receita,
      categoria: categoria,
      promotor: promotor,
    })
  },

  showDelhamentoClientesDadosPerfomance: (primeiroDia, ultimoDia, select, tokenContrato, vendedorSelect, areaSelect, redeSelect, supervisorSelect, receita, categoria, promotor) => {
    return http.post(route + 'showDelhamentoClientesDadosPerfomance', {
      dataInicio: primeiroDia,
      dataFim: ultimoDia,
      select: select,
      tokenContrato: tokenContrato,
      vendedor: vendedorSelect,
      area: areaSelect,
      rede: redeSelect,
      supervisor: supervisorSelect,
      receita: receita,
      categoria: categoria,
      promotor: promotor,
    })
  },

  showDelhamentoMaioresCrescimento: (primeiroDia, ultimoDia, select, tokenContrato, vendedorSelect, areaSelect, redeSelect, supervisorSelect, receita, categoria, promotor) => {
    return http.post(route + 'showDelhamentoMaioresCrescimento', {
      dataInicio: primeiroDia,
      dataFim: ultimoDia,
      select: select,
      tokenContrato: tokenContrato,
      vendedor: vendedorSelect,
      area: areaSelect,
      rede: redeSelect,
      supervisor: supervisorSelect,
      receita: receita,
      categoria: categoria,
      promotor: promotor,
    })
  },

  showDadosClientesPioresCrescimento: (primeiroDia, ultimoDia, select, tokenContrato, vendedorSelect, areaSelect, redeSelect, supervisorSelect, receita, categoria, promotor) => {
    return http.post(route + 'showDadosClientesPioresCrescimento', {
      dataInicio: primeiroDia,
      dataFim: ultimoDia,
      select: select,
      tokenContrato: tokenContrato,
      vendedor: vendedorSelect,
      area: areaSelect,
      rede: redeSelect,
      supervisor: supervisorSelect,
      receita: receita,
      categoria: categoria,
      promotor: promotor,
    })
  },

  showExtratoClienteMixComercializado: (primeiroDia, ultimoDia, clientes, select, tokenContrato, vendedorSelect, areaSelect, redeSelect, supervisorSelect, receita) => {
    return http.post(route + 'showExtratoClienteMixComercializado', {
      dataInicio: primeiroDia,
      dataFim: ultimoDia,
      clientes: clientes,
      select: select,
      tokenContrato: tokenContrato,
      vendedor: vendedorSelect,
      area: areaSelect,
      rede: redeSelect,
      supervisor: supervisorSelect,
      receita: receita,
    })
  },

  showExtratoClienteProdutosVender: (primeiroDia, ultimoDia, clientes, select, tokenContrato, vendedorSelect, areaSelect, redeSelect, supervisorSelect, receita, categoria, promotor) => {
    return http.post(route + 'showExtratoClienteProdutosVender', {
      dataInicio: primeiroDia,
      dataFim: ultimoDia,
      clientes: clientes,
      select: select,
      tokenContrato: tokenContrato,
      vendedor: vendedorSelect,
      area: areaSelect,
      rede: redeSelect,
      supervisor: supervisorSelect,
      receita: receita,
      categoria: categoria,
      promotor: promotor,
    })
  },
  showComparativoCadProdutores: (primeiroDia, ultimoDia, empresaSelect, tokenContrato, linhaSelect) => {
    return http.post(route + 'showComparativoCadProdutores', {
      dataInicio: primeiroDia,
      dataFim: ultimoDia,
      empresa: empresaSelect,
      tokenContrato: tokenContrato,
      linhasleite: linhaSelect,
    })
  },
}
